import React, {useState} from "react";
//
// interface NavigationState {
//     activeItem: string
// }
//
//
// export class Navigation extends React.Component<{}, NavigationState> {
//
//     state = {
//         activeItem: window.location.href.substr(window.location.href.lastIndexOf('/') + 1)
//     }
//
//     onArrowClick = (currentPage: string) => {
//         this.setState({activeItem: currentPage})
//     }

function Navigation(){
    let [Drop1,setDrop1]=useState("drop1 dropdown-menu text-left");
    let [Drop2,setDrop2]=useState("drop1 dropdown-menu text-left");

    let [navclass,setNav]=useState("collapse navbar-collapse");

    let [status1,setStatus1]=useState("on");
    let [status2,setStatus2]=useState("on");

    let [opac1,setOpac1]=useState("./images/white.png");

    let [nav1,setNav1]=useState("");
    let [nav2,setNav2]=useState("");
    let [nav3,setNav3]=useState("");
    let [nav4,setNav4]=useState("");
    let [nav5,setNav5]=useState("");
    let [nav6,setNav6]=useState("");

    function HideNav(){
        setNav("collapse navbar-collapse show");
    }
    function hideBar(event:any){
        if(event.target.id==="link21"||event.target.id==="link22"||event.target.id==="link23"||event.target.id==="link24"||event.target.id==="link25"||event.target.id==="link26"){
            HideDrop2();
            setNav("collapse navbar-collapse hide");
        }
        else if(event.target.id==="link11"||event.target.id==="link12"||event.target.id==="link13"||event.target.id==="link14"||event.target.id==="link15"||event.target.id==="link16"){
            HideDrop1();
            setNav("collapse navbar-collapse hide");
        }
        // HideDrop1();


    }


    function HideDrop1(){

        // let Dropid=document.getElementById("dropM1");
        // alert(Dropid);
        if(status1==="on") {
            setStatus1("off");
            setDrop1("drop1 dropdown-menu text-left show");

            // setStatus2("on");
            // setDrop2("drop1 dropdown-menu text-left");
        }
        else if(status1==="off"){
            setStatus1("on");
            setDrop1("drop1 dropdown-menu text-left");
        }

    }
    function HideDrop2(){
    //     let Dropid;
    //     // Dropid=event.target.id;
    //     // alert(Dropid);
        if(status2==="on") {
            setStatus2("off");
            setDrop2("drop1 dropdown-menu text-left show");
    //
            // setStatus1("on");
            // setDrop1("drop1 dropdown-menu text-left");
        }
        else if(status2==="off"){
            setStatus2("on");
            setDrop2("drop1 dropdown-menu text-left");
        }
    //
    }
    window.onload=function(){


    }
    window.onscroll=function(){
        // alert(window.scrollY);
        if(window.scrollY<310){
            setOpac1("./images/white.png");
            if(window.location.pathname==="/" || window.location.pathname==="/home"){
                setNav1("#24a048");
                setNav2("white");
                setNav3("white");
                setNav4("white");
                setNav5("white");
                setNav6("white");

            }
            else if(window.location.pathname==="/VajraVihar"){
                setNav1("white");
                setNav2("#24a048");
                setNav3("white");
                setNav4("white");
                setNav5("white");
                setNav6("white");
            }
            else if(window.location.pathname==="/services"){
                setNav1("white");
                setNav2("white");
                setNav3("white");
                setNav4("#24a048");
                setNav5("white");
                setNav6("white");
            }
            else if(window.location.pathname==="/about"){
                setNav1("white");
                setNav2("white");
                setNav3("white");
                setNav4("white");
                setNav5("#24a048");
                setNav6("white");
            }
            else if(window.location.pathname==="/contact"){
                setNav1("white");
                setNav2("white");
                setNav3("white");
                setNav4("white");
                setNav5("white");
                setNav6("#24a048");
            }
            // setOpac2("none");
        }
        else if(window.scrollY>310){
            setOpac1("./images/blackk.png");

            if(window.location.pathname==="/" || window.location.pathname==="/home"){
                setNav1("#24a048");
                setNav2("black");
                setNav3("black");
                setNav4("black");
                setNav5("black");
                setNav6("black");

            }
            else if(window.location.pathname==="/VajraVihar"){
                setNav1("black");
                setNav2("#24a048");
                setNav3("black");
                setNav4("black");
                setNav5("black");
                setNav6("black");
            }
            else if(window.location.pathname==="/services"){
                setNav1("black");
                setNav2("black");
                setNav3("black");
                setNav4("#24a048");
                setNav5("black");
                setNav6("black");
            }
            else if(window.location.pathname==="/about"){
                setNav1("black");
                setNav2("black");
                setNav3("black");
                setNav4("black");
                setNav5("#24a048");
                setNav6("black");
            }
            else if(window.location.pathname==="/contact"){
                setNav1("black");
                setNav2("black");
                setNav3("black");
                setNav4("black");
                setNav5("black");
                setNav6("#24a048");
            }


        }
    }


    return(
            <div>

            <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light" id="ftco-navbar">
                <div className="container-fluid p-0">
                    <a className="navbar-brand" href={"home"} style={{fontFamily: 'Lucida Handwriting',maxWidth:"100px"}}>

                        <img className="hut ml-5" alt="img" src={opac1} width="120px" style={{transform:"scale(1.45,1.45)"}}/>
                        {/*<img className="hut" alt="img" src="./images/white.png" width="118px" style={{transform:"translateX(0px)",display:opac1}}/>*/}
                        {/*<img className="hut" alt="img" src="./images/black.png" width="90px" style={{transform:"translateX(0px)",display:opac2}} />*/}
                        {/*<img className="hut" alt="img" src="./images/text1.png" width="118px" style={{transform:"translate(-10px,-10px)",display:opac2}} />*/}
                        {/*<img className="hut" alt="img" src="./images/text2.png" width="125px" height="15px" style={{transform:"translate(-130px,10px) scale(1.08,1.08)",display:opac2}} />*/}
                        {/*<img className="hut" alt="img" src="./images/whitetext1.png" width="100px" style={{transform:"translate(-10px,-10px)",display:opac1}} />*/}
                        {/*<img id="hut" alt="img" src="./images/whitetext2.png" width="100px" height="15px" style={{transform:"translate(-110px,10px) scale(1.08,1.08)",display:opac1}} />*/}

                    </a>
                    <button style={{position:"absolute",top:"20px",right:"20px"}} className="navbar-toggler" type="button" data-toggle="collapse" data-target="#ftco-nav" onClick={HideNav}
                            aria-controls="ftco-nav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="fa fa-bars"/>
                    </button>

                    <div className={navclass} id="ftco-nav">
                        <ul className="navbar-nav ml-auto">


                            <li className="nav-item">
                                <div className="dropdown">
                                    <a href={"/home"} className="nav-link d-inline-block" style={{color:nav1}}>Home</a>&nbsp;&nbsp;<a
                                     className="dropdown-toggle nav-link d-inline-block" style={{color:nav1}} id={status1} onClick={HideDrop1}/>
                                    <div className={Drop1} id="dropM1">
                                        <a className="dropdown-item text-dark" id="link11" onClick={hideBar} href={"/home#aboutus"}>About</a>
                                        <a className="dropdown-item text-dark" id="link12" onClick={hideBar} href={"/home#services"}>Services</a>
                                        <a className="dropdown-item text-dark" id="link13" onClick={hideBar} href={"/home#projects"}>Projects</a>
                                        <a className="dropdown-item text-dark" id="link14" onClick={hideBar} href={"/home#properties"}>Properties</a>
                                        <a className="dropdown-item text-dark" id="link15" onClick={hideBar} href={"/home#workflow"}>Work Flow</a>
                                        <a className="dropdown-item text-dark" id="link16" onClick={hideBar} href={"/home#happyclients"}>Happy Clients</a>
                                    </div>
                                </div>
                            </li>


                            <li className="nav-item">
                                <div className="dropdown">
                                    <a
                                        href={"/VajraVihar"} className="nav-link d-inline-block" style={{color:nav2}}>Vajra
                                        Vihar </a>&nbsp;&nbsp;
                                    <a className="dropdown-toggle d-inline-block nav-link" id={status2} style={{color:nav2}} onClick={HideDrop2} />
                                    <div className={Drop2}>
                                        <a className="dropdown-item text-dark" id="link21"  href={"/VajraVihar#overview" } onClick={hideBar}>Overview</a>
                                        <a className="dropdown-item text-dark" id="link22" href={"/VajraVihar#features"} onClick={hideBar}>Property Features</a>
                                        <a className="dropdown-item text-dark" id="link23" href={"/VajraVihar#benefits"} onClick={hideBar}>Major Benefits</a>
                                        <a className="dropdown-item text-dark" id="link24" href={"/VajraVihar#location"} onClick={hideBar}>Location</a>
                                        <a className="dropdown-item text-dark" id="link25" href={"/VajraVihar#plans"} onClick={hideBar}>Plans</a>
                                        <a className="dropdown-item text-dark" id="link26" href={"/VajraVihar#neighbourhood"} onClick={hideBar}>Neighbourhood</a>
                                    </div>
                                </div>
                            </li>
                            <li className="nav-item">
                                <div className="dropdown">
                                    <a
                                        onClick={hideBar} href={"/home#properties"} className="nav-link d-inline-block" style={{color:nav3}}>Our
                                        Properties </a>&nbsp;&nbsp;
                                    {/*<a data-toggle="dropdown" className="dropdown-toggle nav-link d-inline-block"/>*/}
                                    {/*<div className="drop1 dropdown-menu text-left">*/}
                                        {/*<a className="dropdown-item text-dark" >Disabled</a>*/}
                                        {/*<a className="dropdown-item text-dark" >Disabled</a>*/}
                                        {/*<a className="dropdown-item text-dark" >Disabled</a>*/}
                                    {/*</div>*/}
                                </div>
                            </li>

                            <li className="nav-item">
                                <div className="dropdown">
                                    <a
                                        href={"/services"} className="nav-link d-inline-block" style={{color:nav4}}>Services </a>
                                </div>
                            </li>
                            <li className="nav-item">
                                <div className="dropdown">
                                    <a href={"/about"} className="nav-link d-inline-block" style={{color:nav5}}>About </a>
                                </div>
                            </li>

                            <li className="nav-item">
                                <div className="dropdown">
                                    <a href={"/contact"} className="nav-link d-inline-block" style={{color:nav6}}>Contact Us </a>
                                </div>
                            </li>


                        </ul>
                    </div>

                </div>
            </nav>
        </div>

        );
    }
export default Navigation;